import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FullTable } from 'components';
import { useModal } from 'utils';
import { goalActions } from 'store';
import { dataCollectionBody, dataCollectionHead, dataCollectionNotYet, ACTION_TYPE } from './constants';
import { TrialData } from '../trialData/trialData';

export const DataCollection = ({ goalId }) => {
    const goalSessions = useSelector((state) => state.goals.goalSessions);
    const dispatch = useDispatch();
    const { open } = useModal();

    useEffect(() => {
        dispatch(goalActions.getGoalSessions(goalId));
    }, []);
    const handleClickButton = (item, name) => {
        if (name === 'detail') {
            open(<TrialData session={item} />);
        }
    };

    const afterSuccess = () => {
        dispatch(goalActions.getGoalSessions(goalId));
    };

    return (
        <div>
            <FullTable
                head={dataCollectionHead}
                body={dataCollectionBody(afterSuccess)}
                notYet={dataCollectionNotYet}
                loadingType={ACTION_TYPE}
                list={goalSessions}
                handleClickButton={handleClickButton}
                margin={'0'}
                activeRowId={''}
                height={'medium'}
            />
        </div>
    );
};
